import { Injectable } from "@angular/core";
import { MenuClient, MenuLinkViewModel } from "src/domain/client";
import { BrandService } from "./brand.service";
import { ChannelRequestService } from "./channel-request.service";
import { firstValueFrom } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class NavigationService {
  constructor(
    private brandService: BrandService,
    private channelRequestService: ChannelRequestService,
  ) {}

  async getMenu(): Promise<MenuLinkViewModel[]> {
    let channelRequestId =
      this.channelRequestService.channelRequest?.channelRequestId;
    if (!channelRequestId) {
      ({ channelRequestId } = await firstValueFrom(
        this.channelRequestService.channelRequestUpdated$,
      ));
    }
    if (!channelRequestId) {
      throw new Error("No channelRequestId specified");
    }
    return new MenuClient().menu(channelRequestId, this.brandService.brandId);
  }
}
